import EventBus from "@packages/event-bus";
import Vue from "vue";
import base from "./baseAuth";

export default Object.assign(
    {
        apiUrl: "/user",

        async alterPassword({ oldPassword, newPassword }) {
            const url = this.url(`/password`);

            return Vue.http.put(url, {
                senha: newPassword,
                senhaAtual: oldPassword,
            });
        },

        async search({ filter = "", page = 0 } = {}) {

            const nodeList = await Vue.http.get(`/auth`+this.apiUrl+"/", {
                params: {
                    filter,
                    page
                },
            });

            return nodeList;
        },

        async searchNest({ filter = "", page = 0 } = {}) {
            const url = this.userUrl({
                path: `/nestsearch/${page}`,
            });

            const nodeList = await Vue.http.get(url, {
                params: {
                    filter,
                },
            });

            return nodeList;
        },

        async changeAccountDetails(accountDetails) {
            const url = this.url('/account');
            const response = await Vue.http
                .put(url, accountDetails)
                .catch((error) => {
                    EventBus.$emit("CANCEL_SPINNER");
                    throw error;
                });
            return response;
        },

        async searchAsFilter({ filter = "" } = {}) {
            const url = this.userUrl({ path: `/search/` });

            const nodeList = await Vue.http.get(url, {
                params: {
                    filter,
                },
            });

            return nodeList;
        },

        async create({ name, email, password, parentId, phoneNumber, role }) {
            // const url = this.userUrl({ path: `/` });

            return Vue.http.post(`/auth`+this.apiUrl+"/", {
                name: name,
                login: email,
                senha: password,
                parentId,
                phoneNumber,
                role
            });
        },

        async edit({ id, name, email, password, parentId, phoneNumber, role }) {
            const url = this.url(`/${id}`);

            return Vue.http.put(url, {
                name: name,
                login: email,
                senha: password,
                parentId,
                phoneNumber,
                role
            });
        },

        async alterPermission({ userId, permission }) {
            const url = this.url( `/${userId}/role/${permission}`);

            return Vue.http.patch(url);
        },


        async listPermissions() {
            const url = this.url( `/permissions`);

            return Vue.http.get(url);
        },

        async open({ id, page = 0 }) {
            const url = this.userUrl({
                path: `/${id}/open/${page}`,
            });

            return Vue.http.get(url);
        },

        async alterPosition({ id, dest }) {
            const url = this.userUrl({
                path: `/${id}/position/${dest}`,
            });

            return Vue.http.put(url);
        },

        async delete({ id }) {
            const url = this.url(`/${id}/`);

            return Vue.http.delete(url);
        },

        async uploadAvatar({ data }) {
            const url = this.url(`/avatar`);
            const options = {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: localStorage.getItem("token"),
                },
            };

            return Vue.http.post(url, data, options);
        },

        async changeMaster ({id}) {
            const url = this.url(`/${id}/role`);
            return Vue.http.patch(url)

        }
    },
    base
);
